import React, { useEffect } from "react";
// Removed font-awesome package used only here for some reason
// import "font-awesome/css/font-awesome.min.css";
// import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.js",
  import.meta.url
).toString();
import axios from "../../../Axios";
import { Urls } from "../../../Urls";
export const ViewFile = ({ file, trackingFunction = () => {} }) => {
  if (!file || !file.fileName) return null;

  const getCleanUrl = (url) => url?.split("?")[0];
  const fileName = file.fileName.split("?")[0];
  const fileExtension = fileName.split(".").pop().toLowerCase();
  const allowedImageExtensions = ["jpg", "jpeg", "png", "bmp"];

  const isImageFile = allowedImageExtensions.includes(fileExtension);
  const fileUrl = getCleanUrl(file.fileUrl);

  useEffect(() => {
    if (trackingFunction) {
      trackingFunction();
    }
  }, []);

  // Function to render the image
  const renderImage = () => {
    if (!fileUrl) {
      return (
        <span className="m-5 w-100 text-center">
          An error occurred. Could not load file.
        </span>
      );
    }
    return (
      <img
        src={fileUrl}
        alt="file preview"
        width="100%"
        height="400"
        style={{ border: "none", marginTop: 0 }}
        loading="lazy"
      />
    );
  };

  // Function to render the document (e.g., PDF)
  const renderDocument = () => (
    <Document file={fileUrl} height={550}>
      <Page pageNumber={1} />
    </Document>
  );

  // Download button
  const renderDownloadButton = () => (
    <div className="mb-2">
      <a href={fileUrl} download={fileName} className="btn btn-primary">
        Download
      </a>
    </div>
  );

  return (
    <div className="row col-md-12 my-2">
      {renderDownloadButton()}
      {isImageFile ? renderImage() : renderDocument()}
    </div>
  );
};

export const handleFileDownload = (url, trackingFunction = () => {}) => {
  if (url) {
    window.open(url?.split("?")[0]);
  }

  if(trackingFunction) {
    trackingFunction()
  }
};

export const STATUS_MAPPING = {
  ALL: "all",
  PENDING_REVIEW: "pending",
  APPROVED: "approved",
  UNDER_CLARIFICATION: "clarity_needed",
  ON_HOLD: "onhold",
  REJECTED: "rejected",
};

export const handleInvoiceStatusChange = async (
  tax_invoice_id,
  remarks,
  status,
  accountType,
  trackInvoiceEvent,
  debitNote = null,
  erpNo = null,
  utrNo = null
) => {
  const url = `${Urls.invoice}?field=update_status&status=${status}`;

  const payload = [
    {
      tax_invoice_id,
      invoice_status: status === "open" ? "pending" : status,
      team: accountType === "FIN" ? "accounts" : "operation",
      remarks,
      debit_note: debitNote,
      erp_no: erpNo,
      utr_no: utrNo,
    },
  ];

  try {
    const { data } = await axios.post(url, payload);
    trackInvoiceEvent(
      "invoice screen",
      `user has updated invoice status`,
      `status : ${status}, invoice id : ${tax_invoice_id}`
    );
    return data;
  } catch (error) {
    console.error("Error updating invoice status to", status, error);
    throw error;
  }
};

export const formatNumberToTwoDecimals = (value) => {
  return formatNumberWithCommas(parseFloat(value || 0).toFixed(2));
};

export const formatNumberWithCommas = (value) => {
  return new Intl.NumberFormat("en-IN").format(value);
};

export const getFile = (file_uploads, type) => {
  const matchingFiles = file_uploads?.filter(
    (file) => file?.type === type && !file?.is_deleted
  );
  return matchingFiles?.pop() || null;
};

export const invoiceTabs = [
  { value: "activeInvoices", label: "Active Invoices" },
  { value: "accounted", label: "Accounted" },
];

export const formatDateToYYYY_MM_DD = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = (d.getMonth() + 1).toString().padStart(2, "0");
  const day = d.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const closeModal = (closeButtonId = "close_contactus") => {
  const closeButton = document.getElementById(closeButtonId);
  if (closeButton) {
    closeButton.click();
  }
};

export { formatDateForDisplay } from "../../../Constants";
